import { useLanguage } from '../../shell/language-context';

// Per-tile geometry from the design (DC:530-584): width clamp (min px, vw, max px),
// corner radius, vertical offset and tilt — an organic scatter rather than a strip.
type Tile = [min: number, vw: number, max: number, radius: number, y: number, rot: number];
const ROW_A: Tile[] = [
  [74, 8.4, 116, 26, -8, 0],
  [64, 7.4, 100, 24, 10, 0],
  [80, 9, 126, 28, -14, -3],
  [64, 7.4, 100, 24, 6, 0],
  [74, 8.4, 116, 26, -4, 3],
  [68, 7.8, 106, 24, 12, 0],
  [78, 8.8, 122, 26, -10, 0],
  [64, 7.4, 100, 24, 8, -2],
  [74, 8.4, 116, 26, -6, 0],
  [68, 7.8, 106, 24, 14, 2],
];
const ROW_B: Tile[] = [
  [74, 8.4, 116, 26, 8, 0],
  [64, 7.4, 100, 24, -10, 2],
  [78, 8.8, 122, 26, 12, 0],
  [64, 7.4, 100, 24, -6, -3],
  [74, 8.4, 116, 26, 10, 0],
  [80, 9, 126, 28, -14, 0],
  [64, 7.4, 100, 24, 6, 3],
  [74, 8.4, 116, 26, -8, 0],
  [68, 7.8, 106, 24, 12, -2],
  [74, 8.4, 116, 26, -4, 0],
];

function Row({ photos, tiles, reverse }: { photos: string[]; tiles: Tile[]; reverse?: boolean }) {
  // Two copies back to back so the -50% loop is seamless; decorative, so alt="".
  const cells = [...tiles, ...tiles];
  return (
    <div className="hm-comm__row">
      <div className={reverse ? 'hm-comm__track hm-comm__track--rev' : 'hm-comm__track'} data-marquee="true">
        {cells.map(([min, vw, max, radius, y, rot], i) => (
          <img
            key={i}
            className="hm-comm__tile"
            src={photos[i % photos.length]}
            alt=""
            loading="lazy"
            decoding="async"
            style={{
              width: `clamp(${min}px, ${vw}vw, ${max}px)`,
              borderRadius: radius,
              transform: `translateY(${y}px)${rot ? ` rotate(${rot}deg)` : ''}`,
            }}
          />
        ))}
      </div>
    </div>
  );
}

// "You will find your next plan here." — two rows of listing photos drifting in
// opposite directions around the title (design community marquee). The photos are
// the covers of the listings the home aggregate returned, not stock imagery.
export function CommunityMarquee({ photos }: { photos: string[] }) {
  const { t } = useLanguage();
  if (photos.length === 0) return null;
  const half = Math.ceil(photos.length / 2);
  const a = photos.slice(0, Math.max(half, 1));
  const b = photos.slice(half).length ? photos.slice(half) : a;
  return (
    <section className="hm-comm">
      <Row photos={a} tiles={ROW_A} />
      <div className="hm-comm__copy">
        <h2 className="hm-comm__title">{t('dc50.next.title')}</h2>
        <p className="hm-comm__sub">{t('dc50.next.sub')}</p>
      </div>
      <Row photos={b} tiles={ROW_B} reverse />
    </section>
  );
}
